<template>
  <div class="content">
    <div class="con" v-for='(list,index) in lists' :key='index' @click='gotodetal(list.id,list.faceimg,list.title)' >
      <div class="space">
        {{list.tags.split(',')[0]}} <span class='line'>|</span>{{list.tags.split(',')[1]}}
      </div>
      <img class='pic' :src="list.faceimg" alt="" >
      <p class='title'>{{list.title}}</p>
      <div class="name">
        <div class="left">
          <img class='avart' :src="list.publishuserimg" alt="">
          <span class='avartname'>{{list.publishusername}}</span>
        </div>
        <div class="right">
          <span class='concolor'>出行时间：{{list.travelstartdate}}至{{list.travelenddate}}</span>
        </div>
      </div>
      <div class="listcontent concolor" style="margin-bottom:28px;">{{list.introduce}}</div>
      <div class="name">
        <div class="left">
          <img src="../../static/images/eye.jpg" alt="">
          <span class='concolor'>{{list.visitornum}}浏览</span>
        </div>
        <div class="right concolor">发布于{{list.publishedtime}}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    lists: {
      default: () => {
        return []
      },
      type: Array,
      required: true
    }
  },
  methods: {
    // 跳转详情页
    gotodetal (id, img, title) {
      this.$router.push({
        name: 'PastReviewDetail',
        params: {
          id: id,
          img: img,
          title: title
        }
      })
    }
  }
}
</script>
<style scoped>
  .content{
    height:auto;
    /* overflow: auto; */
    margin:auto;
    margin-top:1.5rem;
    padding-bottom:2rem;
    width: 78.5rem;
    column-count: 3;
    -moz-column-count:3;
-webkit-column-count:3;
    /* column-gap: 1.5rem;
    -moz-column-gap:1.5rem;
-webkit-column-gap:1.5rem; */
  }
  .con{
    cursor: pointer;
    break-inside: avoid;
    -moz-page-break-inside: avoid;
    -webkit-column-break-inside: avoid;
    width:395px;
    /* height: auto; */
    position: relative;
    margin-bottom: 1.5rem;
    border:1px solid rgba(232, 232, 232, 1);
     transition: all .3s;
     transform: translateY(0px);
  }

  .con:hover {
    break-inside: avoid;
    -moz-page-break-inside: avoid;
    -webkit-column-break-inside: avoid;
    box-shadow: 5px 5px 10px 1px #e8e8e8;
    /* margin-top:-3px; */
     transition: all .3s;
     transform: translateY(-3px);
  }
  .name{
    display:flex;
    align-items: center;
    justify-content: space-between;
    /* padding-bottom:1.25rem; */
  }
  .left{
    display:flex;
    align-items:center;
  }
  .left span{
    margin-left:.5rem
  }
  .pic{
    width:100%;
  }
  .title{
    font-size:1.125rem;
    color:#434343;
    margin:18px 10px;
  }
  .avartname{
    font-size:.875rem;
    color:#434343;
  }
  .concolor{
    font-size:.875rem;
    color:#7a7a7a;
    line-height:24px;
  }

  .avart{
    width:1.875rem;
    height:1.875rem;
  }
  .listcontent,.name{
    margin-left:10px;
    margin-bottom:18px;
    margin-right:10px;
  }
  .space{
    position:absolute;
    top:0;
    left:0;
    height:2.125rem;
    background-color: rgb(0,0,0,.2);
    color:#fff;
    font-size:.875rem;
    line-height: 2.125rem;
    padding: 0 .875rem;
  }
  .line{
    color:#d3d3d3;
    margin:0 .75rem;
  }
  .more{
    font-size: .875rem;
    color:#6a7176;
    font-style:italic;
    text-align: center;
    margin-top:5.5rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/past/past.vue